<script>
import ImageContainer from './components/ImageContainer.vue';

export default {
    name: 'App',
    components: {
        ImageContainer,
    },
    data() {
        return {
            showAbout: true,
            showPhotography: false,
        };
    },
    methods: {
        showHome() {
            this.showAbout = true;
        },
        showProjects() {
            this.showAbout = false;
            this.showPhotography = false;
        },
        showPhoto() {
            this.showAbout = false;
            this.showPhotography = true;
        },
    },
};
</script>

<template>
    <div class="main-container">
        <div class="navbar">
            <h4 :class="showAbout ? 'active' : null" @click="showHome">Home</h4>
            <a href="https://feed.konrad-amtenbrink.com"><h4>Feed</h4></a>
            <h4 :class="!showAbout && showPhotography ? 'active' : null" @click="showPhoto">
                Photography
            </h4>
            <a href="mailto: mail@konrad-amtenbrink.com"><h4>Contact</h4></a>
        </div>
        <div v-if="showAbout" class="about-container">
            <div class="content">
                <h1>Konrad</h1>
                <h2>Software developer</h2>
            </div>
        </div>
        <div v-else>
            <div v-if="showPhotography">
                <ImageContainer />
                <div class="cover"></div>
            </div>
            <div v-else></div>
        </div>
    </div>
</template>

<style lang="postcss" scoped>
.cover1 {
    height: 100vh;
    width: 100vw;
    background: transparent;
}
</style>

<style lang="postcss">
@import url('https://fonts.googleapis.com/css2?family=Chakra+Petch&display=swap');

body {
    height: 100vh;
    width: 100vw;
    background-color: #202020;
    margin: 0;
    overflow: hidden;
}

.navbar {
    position: absolute;
    width: 432px;
    height: 26px;
    margin-top: 2rem;
    left: 50%;
    transform: translate(-50%, 0);

    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    color: #dfdfdf;
    z-index: 10;
}

.navbar > h4 {
    margin: 1.5rem;
    cursor: pointer;
}

.navbar > .active {
    text-decoration-line: underline;

    color: #fed94f;
}

.content {
    position: relative;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.content > h1 {
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 400;
    font-size: 96px;
    line-height: 125px;

    margin: 0;
    padding: 0;

    color: #fed94f;
}

.content > h2 {
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 400;
    font-size: 40px;
    line-height: 52px;

    margin: 0;
    padding: 0;

    color: #dfdfdf;
}

.content > a {
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 400;
    font-size: 40px;
    line-height: 52px;

    margin: 0;

    color: #dfdfdf;
}

a {
    color: #dfdfdf;
}

a:link {
    text-decoration: none;
}

a:visited {
    text-decoration: none;
}

a:hover {
    text-decoration: none;
}

a:active {
    text-decoration: none;
}

* {
    font-family: 'Chakra Petch';
}
</style>
